import React from "react";
import { Link } from "react-router-dom";
import logo from '../../logo.svg';

function Footer() {
    return (
        <footer className="w-full bg-[#111111] border-t border-[#222222]">
            <div className="max-w-5xl mx-auto px-6 py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
                <Link to="/">
                    <img src={logo} width="36" height="36" alt="MyGameName" />
                </Link>
                <nav className="flex gap-6 text-sm text-[#F5F5F5]/60">
                    <Link to="/create" className="hover:text-[#8B5CF6] transition-colors">Create</Link>
                    <Link to="/names" className="hover:text-[#8B5CF6] transition-colors">Names</Link>
                    <Link to="/faq" className="hover:text-[#8B5CF6] transition-colors">FAQ</Link>
                    <Link to="/about" className="hover:text-[#8B5CF6] transition-colors">About</Link>
                </nav>
                <span className="text-xs text-[#F5F5F5]/30">©2024 MyGameName</span>
            </div>
        </footer>
    );
}

export default Footer;
